// extracted by mini-css-extract-plugin
export var text = "_w-0";